import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Col, InputGroup, Input, Alert} from 'reactstrap'
import Countdown from 'react-countdown-now';
import FontAwesome from 'react-fontawesome';

import Button from '../../../Forms/Button'
import {isNumeric} from '../../../../helpers/regex'

const rendered = (data) => {
  if (data.completed) {
    // Render a completed state
    return (<p className="count" onClick={()=>{data.onClick()}}>Kirim Ulang SMS. (60)</p>);
  } else {
    // Render a countdown
    return (<p className="count now" disabled>Kirim Ulang SMS. <span id="">{`(${data.seconds})`}</span></p>)
  }
}

class SubmitVerify extends PureComponent {
  state = {
    // numberOTP: '',
    countNow: true,
    _error: false,
    _disable: false,
    _message: null
  }

  _inputOtp = (e) => {
    // let countNo = this.state.numberOTP
    if(e.target.value === "" || isNumeric(e.target.value))
      if(e.target.value.length < 7)
        this.numberOTP = e.target.value
  }

  _sendSmsAgain = () => {
    this.setState({countNow: true}, () => this.props.onClick.sentSMS())
  }

  _onTick = (data) => {
    // console.log('on thick', data);
    if(data.completed)
      this.setState({countNow: false})
  }

  _submitVerify = () => {
    if(this.numberOTP)
      return this.setState({_disable: true, _error: false},()=>{
        this.props.onClick.submitVerify(this.numberOTP)
      })

    return this.setState({_error: true, _message: "Masukkan code OTP Anda"})
  }

  _handleKeyPress = (event) => {
    const re = /[0-9]+/g;
      if (!re.test(event.key)) {
        event.preventDefault();
      }
  }

  _splitNumber = (mobile_number) => {
    let num_phone_default = '+62-- ---- ---- --'
    let regex = /^\W\d{4}|\d{1,4}/g
    let split_num = mobile_number.match(regex).join(' ')

    return mobile_number ? split_num : num_phone_default
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.dataVerify.isFetch && this.props.dataVerify.error && this.state._disable)
      this.setState({_disable: !this.state._disable, _error: true, _message: null})
  }

  render(){
    let time = 60
    return(
      <div className="body-otp">
        <Col md={12} id="text-info">
          <div>
            <p>Pengiriman kode SMS OTP berhasil</p>
            <p>SMS terkirim ke {this._splitNumber(this.props.mobile_number)}.
              Mohon menginput 6 digit kode yang Anda dapat dari SMS Kick Avenue ke text box
              dibawah ini.
            </p><br/>
            <p>atau belum mendapat SMS ?</p>
            {
              this.state.countNow ?
                <Countdown date={Date.now() + 60000} precision={3} renderer={rendered} onComplete={this._onTick} />
                :
                <p className="count" onClick={this._sendSmsAgain}>Kirim Ulang SMS. ({time})</p>
            }
          </div>
        </Col>
        <Col md={12} id="progress">
          <div className="progress-verify">
            <p>6 Digit OTP</p>
            <InputGroup size="lg">
              <Input type="text" name="handphone" maxLength="6"
                onKeyPress={this._handleKeyPress}
                onChange={(e)=>this._inputOtp(e)}
              />
            </InputGroup>
          </div>
          <Alert color="danger" isOpen={this.state._error} transition>
            {this.state._message ? this.state._message : `Kode verifikasi Anda salah. `}
            <FontAwesome name="question-circle" style={{fontSize: '0.9rem', marginLeft: '0.35rem'}}/>
          </Alert>
          <Button block size="lg" className="btn-green bold verify" disabled={this.state._disable} buttonText="VERIFIKASI" onClick={this._submitVerify} loadingText="VERIFIYING..."/>
        </Col>
      </div>
    )
  }
}

export default SubmitVerify